module.exports = __webpack_public_path__ + "static/media/edit_icon_list.8ac7ea95.svg";